var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.352 3.952a1.2 1.2 0 0 1 1.697 0l7.2 7.2a1.2 1.2 0 0 1 0 1.697l-7.2 7.2a1.2 1.2 0 1 1-1.697-1.697l5.151-5.152H3.6a1.2 1.2 0 0 1 0-2.4h13.903l-5.151-5.15a1.2 1.2 0 0 1 0-1.697Z",
  fill: "currentcolor"
})));
export default SvgArrowRight;